import { z } from "zod";

export const collectionFormSchema = z.object({
  name: z.string().min(1, "Name is required"),
  description: z.string(),
  tags: z.array(z.string()),
  // Required to mirror the create-collection API input. Forms that don't
  // render this field (the inline AddToCollection create form) seed it from
  // context via `defaultValues`.
  resourceType: z.enum(["file", "dataset", "event"]),
});

export type CollectionFormValues = z.infer<typeof collectionFormSchema>;
